<!-- 登录组件 -->
<template>
  <div>
    <div class="row bar">
      <img :src="lesparkIcon" />
      <div class="text-logo">
        <div>LesPark</div>
        <div>
          <slot name="title">{{ $t('bottomBar.profile') }}</slot>
        </div>
      </div>
      <div class="gas-btn">
        <div @click.stop="gotoApp">
          <slot name="button-text">{{ $t('common.goAndSeed') }}</slot>
        </div>
      </div>
    </div>
    <div id='mask' v-if="isMask" @click="isMask=false">
      <img src="http://static.lespark.cn/activity/img/mark.png" alt="">
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Image } from "element-ui";
import Util from 'Common/util.js';
// import lesparkIcon from '../images/lespark.png';
Vue.use(Image);

export default {
  name: 'bottomBar',
  components: {
    elImage: Image,
  },
  data() {
    return {
      lesparkIcon:'https://static.lespark.cn/pc_img/images/lespark.png',
      isMask:false,
    }
  },
  methods: {
    gotoApp () {
      var weixin = navigator.userAgent.indexOf('MicroMessenger') > -1 //是否为微信浏览器
      var qq = navigator.userAgent.match(/\sQQ/i) !== null //是否QQ
      if (weixin || qq) {
        this.isMask = true
        return
      }
      Util.gotoApp()
    }
  }
}
</script>
<style lang="scss" scoped>
.bar {
  height: 16vw;
  background: #ffffff;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  img {
    margin-left: 2.66667vw;
    width: 10.66667vw;
    height: 10.66667vw;
  }
  .text-logo {
    margin-left: 2vw;
    :first-child {
      font-size: 4.26667vw;
      color: #333333;
      line-height: 6.13333vw;
      font-weight: bold;
    }
    :last-child {
      font-size: 3.2vw;
      color: #333333;
      line-height: 4.66667vw;
    }
  }
}
.gas-btn {
  position: absolute;
  right: 2.66667vw;
  height: 9.33333vw;
  background: linear-gradient(312deg, #ff4646 0%, #ff3bed 100%);
  border-radius: 6vw;
  opacity: 0.9;
  div:first-child {
    font-size: 3.46667vw;
    font-weight: 500;
    color: #ffffff;
    line-height: 4.93333vw;
    margin: 2.26667vw 4.66667vw;
  }
}
#mask {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background: rgba(0, 0, 0, 1);
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  img {
    width: 85%;
    position: absolute;
    top: 0;
    right: 0
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/bottomBar.vue